import store from "../store/store"
import { FOREIGNER } from "../constants/constants"

// Fallback when configs are not loaded yet; managed in Laravel configs table
// via customer_service_phone_number / customer_service_phone_number_foreigner.
// Config values can be raw (+6281290904676); display formatting is applied here.
const DEFAULT_CUSTOMER_SERVICE_PHONE = "+6287889644676"

// +6281290904676 -> +62 812 9090 4676; non-Indonesian numbers are left as-is
function formatSupportPhoneNumber(phone) {
  const digits = phone.replace(/\D/g, "")
  if (!digits.startsWith("62")) {
    return phone
  }
  const subscriber = digits.slice(2)
  const groups = [subscriber.slice(0, 3)]
  for (let i = 3; i < subscriber.length; i += 4) {
    groups.push(subscriber.slice(i, i + 4))
  }
  return `+62 ${groups.join(" ")}`
}

export function getSupportPhoneNumber(locale) {
  const configs = store.getters.configs || {}
  const phone = locale === FOREIGNER.LOCALE
    ? configs.customer_service_phone_number_foreigner
    : configs.customer_service_phone_number
  return formatSupportPhoneNumber(phone || DEFAULT_CUSTOMER_SERVICE_PHONE)
}

export function getSupportWhatsappLink(locale) {
  return `https://wa.me/${getSupportPhoneNumber(locale).replace(/\D/g, "")}`
}
